// Import Actions
import { SET_TAXES, REMOVE_TAX } from './TaxActions';
import { LOGOUT_USER } from '../User/UserActions';

// Initial State
export const initialState = {
    data: [],
};

const TaxReducer = (state = initialState, action) => {
    switch(action.type) {
        case SET_TAXES: {
            const otherTaxes = state.data.filter(tax => !action.taxes.find(taxToSet => taxToSet._id === tax._id));
            return {
                ...state,
                data: otherTaxes.concat(action.taxes),
            };
        }

        case REMOVE_TAX: {
            return {
                ...state,
                data: state.data.filter(tax => tax._id !== action.id),
            };
        }

        case LOGOUT_USER:
            return initialState;

        default:
            return state;
    }
};

export default TaxReducer;
